import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IIcon } from '../../icon/icon.component';
import { ButtonStyle } from '../../../directives/button/button.directive';
import { ICopy } from '../../../pipes/translate/translate.pipe';

@Component({
  selector: 'i2g-dialog-base',
  templateUrl: './dialog-base.component.html',
  styleUrls: ['./dialog-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogBaseComponent implements OnInit {
  @Input() icon: IIcon;
  @Input() title: string | ICopy; // ideally we should only pass ICopy, not string
  @Input() body: string | ICopy;
  @Input() primaryButtonStyle: ButtonStyle = 'emphasis';
  @Input() primaryButtonText: string | ICopy;
  @Input() secondaryButtonText: string | ICopy;
  @Input() disablePrimaryButton = false;
  @Input() disableSecondaryButton = false;

  @Output() primaryButtonClicked = new EventEmitter<void>();
  @Output() secondaryButtonClicked = new EventEmitter<void>();

  @HostBinding('class') hostClass;

  ngOnInit() {
    this.hostClass = this.icon ? 'larger-version' : '';
  }
}
